export const LOAD_INTEGRATIONS = 'LOAD_INTEGRATIONS';
export const CHANGE_INTEGRATIONS_LIST_OPTIONS = 'CHANGE_INTEGRATIONS_LIST_OPTIONS';
export const CLEAR_INTEGRATIONS_LIST_OPTIONS = 'CLEAR_INTEGRATIONS_LIST_OPTIONS';
export const LOAD_INTEGRATION_OPTIONS_LIST = 'LOAD_INTEGRATION_OPTIONS_LIST';
export const CLEAR_INTEGRATION_OPTIONS_LIST = 'CLEAR_INTEGRATION_OPTIONS_LIST';
export const LOAD_INTEGRATION_DETAILS = 'LOAD_INTEGRATION_DETAILS';
export const CLEAR_INTEGRATION_DETAILS = 'CLEAR_INTEGRATION_DETAILS';
export const SAVE_INTEGRATION = 'SAVE_INTEGRATION';
export const SET_INTEGRATION_DETAILS_FOR_EDIT = 'SET_INTEGRATION_DETAILS_FOR_EDIT';
export const CLEAR_INTEGRATION_DETAILS_FOR_EDIT = 'CLEAR_INTEGRATION_DETAILS_FOR_EDIT';
export const TEST_INTEGRATION = 'TEST_INTEGRATION';
export const EXECUTE_INTEGRATION = 'EXECUTE_INTEGRATION';
export const LOAD_INTEGRATIONS_BY_CATEGORY = 'LOAD_INTEGRATIONS_BY_CATEGORY';
export const DELETE_INTEGRATION = 'DELETE_INTEGRATION';
